exports.list = {
    path: '/laporan_penjualan',
    name: 'laporan_penjualan', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_penjualan/List.vue"),
  }